import { render, staticRenderFns } from "./TeacherListActions.vue?vue&type=template&id=5c260407"
import script from "./TeacherListActions.vue?vue&type=script&lang=js"
export * from "./TeacherListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports